// LugarDetalle.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../Firebase/Firebase";
import "./LugarDetalle.css";
import Navbar from "../Components/NavBarV2";
import Footer from "../Components/footer";
import FloatingWhatsApp from "../Components/whatsappbutton.js";
import LoadingScreen from "../Components/loading.js";

const LugarDetalle = () => {
  const { id } = useParams();
  const [lugar, setLugar] = useState(null);
  const [espacios, setEspacios] = useState([]);
  const [imagenActual, setImagenActual] = useState({});
  const [touchStartX, setTouchStartX] = useState(null);

  useEffect(() => {
    const fetchLugar = async () => {
      const ref = doc(db, "lugar", id);
      const snapshot = await getDoc(ref);
      if (snapshot.exists()) {
        setLugar({ id: snapshot.id, ...snapshot.data() });
      }
      console.log(snapshot.data());
      console.log(id);
    };

    const fetchEspacios = async () => {
      const espaciosRef = collection(db, "espacios");
      const q = query(espaciosRef, where("IdLugar", "==", id));
      const snapshot = await getDocs(q);
      const espaciosData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setEspacios(espaciosData);
    };

    fetchLugar();
    fetchEspacios();
  }, [id]);

  if (!lugar) return <LoadingScreen />;

  return (
    <>
      <Navbar />
      <FloatingWhatsApp />
      <div className="lugar-detalle-container">
        <div className="lugar-detalle-card">
          <h2>{lugar.NombreLugar}</h2>
          <img src={lugar.ImagenUrl} alt={lugar.NombreLugar} className="lugar-imagen-detalle" />
          <p><strong>Sector:</strong> {lugar.Sector}</p>
          <p><strong>Ciudad:</strong> {lugar.CiudadLugar}</p>
          <p><strong>Dirección:</strong> {lugar.Direccion}</p>
        </div>

        <div className="espacio-laofi-container">
          <h3 className="espacio-laofi-title">Espacios disponibles</h3>
          <div className="espacio-laofi-grid">
            {espacios.map((espacio) => {
              const total = espacio.Imagenes.length;
              const currentIndex = imagenActual[espacio.id] || 0;

              const handlePrev = (e) => {
                e.preventDefault();
                setImagenActual((prev) => ({
                  ...prev,
                  [espacio.id]: currentIndex === 0 ? total - 1 : currentIndex - 1,
                }));
              };

              const handleNext = (e) => {
                e.preventDefault();
                setImagenActual((prev) => ({
                  ...prev,
                  [espacio.id]: currentIndex === total - 1 ? 0 : currentIndex + 1,
                }));
              };

              const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);

              const handleTouchEnd = (e) => {
                const touchEndX = e.changedTouches[0].clientX;
                const diff = touchStartX - touchEndX;
                if (diff > 30) handleNext(e);
                else if (diff < -30) handlePrev(e);
              };


              return (
                <Link to={`/office/${espacio.id}`} key={espacio.id}>
                  <div className="espacio-laofi-card">
                    <h4 className="espacio-laofi-nombre">{espacio.NombreEspacio}</h4>
                    <div className="espacio-laofi-slider">
                      <button onClick={handlePrev} className="slider-button">‹</button>
                      <img
                        src={espacio.Imagenes[currentIndex]}
                        alt={`Foto ${currentIndex}`}
                        className="espacio-laofi-img"
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                      />
                      <button onClick={handleNext} className="slider-button">›</button>
                    </div>
                    <div className="slider-indicadores">
                      {espacio.Imagenes.map((_, i) => (
                        <span
                          key={i}
                          className={`dot ${i === currentIndex ? "active" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            setImagenActual((prev) => ({
                              ...prev,
                              [espacio.id]: i,
                            }));
                          }}
                        >
                          
                        </span>
                      ))}
                    </div>
                    <p>Capacidad: {espacio.CapacidadMin} - {espacio.CapacidadMax} personas</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="mapa-container">
          <iframe
            title="Google Maps"
            width="100%"
            height="300"
            style={{ border: 0, borderRadius: "10px" }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyB7Sx1jXG9YS5c7Iy-qxOEfkECMh7syeqg&q=${lugar.Latitud},${lugar.Longitud}`}
          ></iframe>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default LugarDetalle;
